import { CandidatesFilter } from '../interfaces/candidatesFilter.interface';
import { FilterOption } from '../interfaces/filterOption.interface';
import { SelectedCandidatesFilter } from '../enums/selectedCandidatesFilter.enum';

const ALL_OPTION_KEY = 'all';

export const FILTER_ALL: FilterOption = {
  id: ALL_OPTION_KEY,
  title: 'All',
};

export const CANDIDATES_FILTER_OPTIONS: CandidatesFilter[] = [
  {
    id: SelectedCandidatesFilter.ALL,
    label: 'All',
  },
  {
    id: SelectedCandidatesFilter.OPEN,
    label: 'Open',
  },
  {
    id: SelectedCandidatesFilter.SHORTLISTED,
    label: 'Pending',
  },
  {
    id: SelectedCandidatesFilter.CLOSED,
    label: 'Closed',
  },
];

export const FIRST_BATCH_LIMIT = 12;
export const FETCH_MORE_LIMIT = 5;
